export default "__VITE_ASSET__321bd800__"